import React from 'react';
import { cn } from '@/lib/utils';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  fluid?: boolean; // Option for ultra-wide screens to use container-fluid style
}

export function Container({ children, className, fluid = false }: ContainerProps) {
  return (
    <div
      className={cn(
        'mx-auto w-full px-4 sm:px-6 lg:px-8',
        // For ultra-wide screens, we use different max-width constraints
        fluid ? 'xl:px-12 2xl:px-16' : 'max-w-7xl 2xl:max-w-[90rem]',
        className
      )}
    >
      {children}
    </div>
  );
}
